module.exports = __webpack_public_path__ + "assets/img/kv-6c4e1bd5.jpg";